import { RcsbD3Constants } from "../RcsbD3Constants";
export class RcsbD3LineManager {
    static plot(config) {
        if (config.trackG.select(RcsbD3Constants.PATH + "#" + config.id).size() == 0)
            config.trackG.append(RcsbD3Constants.PATH)
                .attr(RcsbD3Constants.ID, config.id)
                .style(RcsbD3Constants.STROKE, config.color)
                .style(RcsbD3Constants.STROKE_WIDTH, 0.6)
                .style(RcsbD3Constants.FILL, "none");
        config.trackG.select(RcsbD3Constants.PATH + "#" + config.id)
            .datum(config.points)
            .attr(RcsbD3Constants.D, config.line);
    }
    static move(config) {
        config.trackG.select(RcsbD3Constants.PATH + "#" + config.id)
            .datum(config.points)
            .attr(RcsbD3Constants.D, config.line);
    }
}
